export const CHOICES = {
  URGENT_ISSUE: 'urgent',
  SPECIFIC_TREATMENT: 'services',
  // IDs must match the ones in isUrgentOptions
  URGENT_ID: 'Yes',
  SPECIFIC_TREATMENT_ID: 'No',
};

export const SUB_ROUTES = {
  [CHOICES.SPECIFIC_TREATMENT]: {
    path: 'services',
  },
  [CHOICES.URGENT_ISSUE]: {
    path: 'urgent-issue',
  },
};

export const treatments = [
  {
    id: 3,
    title: 'Braces / Invisalign',
    description:
      'Orthodontic treatment uses Braces, Invisalign, or other appliances to put gentle pressure on your teeth and eventually move them into the right position.',
    isSpecialtyTreatment: true,
  },
  {
    id: 5,
    title: 'Bridges / Dentures',
    description:
      'Bridges and dentures are used to replace missing or badly damaged teeth.',
    isSpecialtyTreatment: true,
  },
  {
    id: 9,
    title: 'Crown / Cap',
    description:
      'A crown (also called a cap) is used to reinforce the damaged part of your tooth protecting it from further damage.',
  },
  {
    id: 16,
    title: 'Cavity / Filling',
    description:
      'Dental fillings use restorative materials to repair teeth that have been compromised due to cavities or trauma.',
  },
  {
    id: 8,
    title: 'Implants',
    description:
      'Dental implants are used to replace missing roots and support replacement teeth.',
    isSpecialtyTreatment: true,
  },
  {
    id: 10,
    title: 'Root Canal',
    description:
      'Root canals treat diseases or abscessed teeth. Once a tooth is injured, cracked, or decayed, it is necessary to open the tooth and clean out the infected tissue in the centre. This space is then filled and the opening sealed.',
    isSpecialtyTreatment: true,
  },
  {
    id: 11,
    title: 'Tooth Extraction',
    description: 'A severely damaged tooth may need to be extracted.',
    isSpecialtyTreatment: true,
  },
  {
    id: 1,
    title: 'Veneers',
    description:
      'Veneers and bonding make your teeth look better by changing their colour, shape, or spacing.',
  },
  {
    id: 7,
    title: 'Whitening',
    description:
      'Tooth whitening lightens teeth and helps to remove stains and discolouration.',
  },
  {
    id: 4,
    title: 'Wisdom Teeth',
    data: 'Wisdom Teeth Removal',
    description:
      "When the jaw isn't large enough to accommodate wisdom teeth, they can become impacted. Wisdom teeth may grow sideways, emerge only part way from the gum, or remain trapped beneath the gum and bone.",
    isSpecialtyTreatment: true,
  },
  {
    id: 'other',
    title: 'Other',
  },
];

export const treatmentCheckupCleaning = {
  id: 'checkup-cleaning',
  title: 'Check-up / Cleaning',
};

export const urgentIssues = [
  {
    id: 'pain',
    title: 'Pain / Toothache',
  },
  {
    id: 'damaged-tooth',
    title: 'Broken / Chipped Tooth',
  },
  {
    id: 'lost-tooth',
    title: 'Lost Tooth',
  },
  {
    id: 'lost-filling',
    title: 'Lost Filling',
  },
  {
    id: 'other',
    title: 'Other',
  },
];
